<template>
  <v-card class="overflow-hidden bg-gray-l br-0" style="height: 100%">
    <header>
      <slot name="header">
        <top-bar title="KYC" v-on:openDrawer="onOpenDrawer"></top-bar>
      </slot>
    </header>

    <nav>
      <slot name="nav">
        <nav-drawer :open="drawer" v-on:closeDrawer="onCloseDrawer"></nav-drawer>
      </slot>
    </nav>
      
    <main>
      <slot name="main">
        <div class="body-wrapper p-lr-20 p-b-15">
          <h1 class="desktop-view m-t-140"></h1>
          <kyc-form v-show="status === 'for-verification' && !loading"
            :disable-verify-button="initiating"
            @initiate="initiate">
          </kyc-form>
          <kyc-status v-show="status !== 'for-verification'"
            :status="status"
            :disable-verify-button="initiating"
            @initiate="initiate">
          </kyc-status>
        </div>
      </slot>
    </main>

    <footer>
      <slot name="footer"></slot>
    </footer>
  </v-card>
</template>

<script>
import NavDrawer from "@/components/shared/NavDrawer";
import TopBar from '../components/shared/TopBar';
import KycForm from '../components/kyc/KycForm'
import KycStatus from '../components/kyc/KycStatus'
import {mapActions, mapGetters} from 'vuex'
import storage from '../utility/storage';

export default {
  name: 'Kyc',
  components: {
    KycForm,
    KycStatus,
    TopBar,
    NavDrawer,
  },
  data () {
    return {
      drawer: false
    }
  },
  mounted () {
    if (storage.getString('is_undermaintenance') == 'true') {
      this.$router.push({name: 'maintenance'})
    }
    this.getKYCDetails()
  },
  methods: {
    ...mapActions('kyc', [
          'getKYCDetails',
          'initiate'
        ]
    ),
    onOpenDrawer(value) {
      this.drawer = value
    },
    onCloseDrawer(value) {
      this.drawer = value
    },
  },
  computed: {
    ...mapGetters('kyc', [ 'status', 'loading', 'initiating'])
  }
}
</script>
